import { z } from "zod";
import { TempAccessGrantSchema } from "./access-grant.schema.js";
import { RequestableRoleSchema } from "./request-access.schema.js";

export const OrgChoiceSchema = z
  .object({
    orgId: z.string().min(1),
    orgName: z.string().min(1),
  })
  .strict();

export type OrgChoice = z.infer<typeof OrgChoiceSchema>;

export const TempAccessOptionsSchema = z
  .object({
    organizations: z.array(OrgChoiceSchema),
    requestableRoles: z.array(RequestableRoleSchema),
  })
  .strict();

export type TempAccessOptions = z.infer<typeof TempAccessOptionsSchema>;

export const TempAccessGrantListSchema = z.array(TempAccessGrantSchema);

export type TempAccessGrantList = z.infer<typeof TempAccessGrantListSchema>;

export const TempAccessGrantParamsSchema = z
  .object({
    userId: z.string().min(1),
    grantId: z.string().min(1),
  })
  .strict();

export type TempAccessGrantParams = z.infer<typeof TempAccessGrantParamsSchema>;
